import type { FeatureCollection } from "geojson"
import type { IPLUData, PluInfoType } from "@/types/explore"
import { geoFetch } from "./geo-fetch"

export const fetchPluDocument = async (lon: number, lat: number): Promise<PluInfoType | null> => {
  try {
    const url = `https://www.geoportail-urbanisme.gouv.fr/api/feature-info/du?lon=${lon}&lat=${lat}&layer=parcels&format=json&typeName=zone_urba`
    const res = await geoFetch(url)
    if (!res.ok) return null
    const json = await res.json()
    const feature = json?.features?.[0]
    if (!feature?.properties?.partition) return null
    const p = feature.properties
    return {
      libelle: p.libelle ?? "",
      libelong: p.libelong,
      datevalid: p.datvalid,
      partition: p.partition,
      gpu_doc_id: p.gpu_doc_id,
      gpu_timestamp: p.gpu_timestamp,
      typezone: p.typezone,
    }
  } catch {
    return null
  }
}

export const getPLUPartitionAreas = async (partition: string): Promise<FeatureCollection> => {
  const res = await geoFetch(`https://apicarto.ign.fr/api/gpu/zone-urba?partition=${partition}`)
  return await res.json()
}

export const getPLUFiles = async (docId: string): Promise<{ name: string; path: string; title: string }[]> => {
  const res = await geoFetch(`https://www.geoportail-urbanisme.gouv.fr/api/document/${docId}/files`)
  return await res.json()
}

export const getPLUByCoordinates = async (lon: number, lat: number): Promise<FeatureCollection | null> => {
  try {
    const res = await fetch(`/api/explore/plu_data?lon=${lon}&lat=${lat}`)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export const getPLUData = async (
  zipCode: string,
  cityName: string,
  libelle?: string,
  lon?: number,
  lat?: number,
): Promise<IPLUData | null> => {
  try {
    const params = new URLSearchParams({ zipCode, cityName })
    if (libelle) params.set("libelle", libelle)
    if (lon !== undefined) params.set("lon", String(lon))
    if (lat !== undefined) params.set("lat", String(lat))
    const res = await fetch(`/api/explore/plu_data?${params.toString()}`)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}
